<template>
  <v-card class="mx-auto" max-width="700" outlined>
    <v-list-item three-line>
      <v-col>
        <v-row class="review-first-row">
          <v-list-item-avatar size="48" color="black">
            <img
              :src="reviewData.fields.PHOTO"
              alt="Reviewer's Profile Picture"
            />
          </v-list-item-avatar>
          <p
            style="font-size: 1.25rem;
  font-weight: bold;"
            class=""
          >
            {{ reviewData.fields.NAME }}
          </p>
          <!-- :value="t.fields.rating" -->
          <v-col class="text-right rating-and-date">
            <v-rating
              readonly
              :value="parseFloat(reviewData.fields.RATING)"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              half-increments
              small
              hover
              aria-label="Rate out of 5 stars"
            >
              <template v-slot:item="props">
                <v-icon aria-label="star" color="amber" size="20">{{
                  props.isFilled ? 'mdi-star' : 'mdi-star-outline'
                }}</v-icon>
              </template>
            </v-rating>
            <p>{{ reviewData.fields.TIMESTAMP | date }}</p>
          </v-col>
        </v-row>
        <v-row style="width: 100%">
          <v-list-item-content>
            <v-list-item-subtitle class="black--text"
              >"{{ reviewData.fields.REVIEW }}"</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-row>
      </v-col>
    </v-list-item>

    <v-card-actions>
      <v-row>
        <v-col>
          <v-btn
            aria-label="Helpful review button"
            class="pl-8 pr-8"
            outlined
            :disabled="isHelpful"
            @click="onHelpful()"
          >
            <v-icon class="pr-2" color="success">
              mdi-thumb-up-outline
            </v-icon>
            Helpful</v-btn
          >
        </v-col>
        <v-col>
          <v-dialog v-model="reportDialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                Click Me
              </v-btn> -->
              <v-btn
                v-bind="attrs"
                v-on="on"
                aria-label="Report review abuse button"
                class=" pl-8 pr-8"
                :disabled="isReported"
                
                outlined
              >
                <!-- @click="onReport()" -->
                <v-icon color="error" class="pr-2">mdi-flag-variant</v-icon>
                Report abuse
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="headline grey lighten-2">
                Why are you reporting this review?
              </v-card-title>

              <v-container class="px-0 ml-6" fluid>
                <v-radio-group v-model="radioGroup">
                  <v-radio label="Irrelevant" v-model="irrelevant"></v-radio>
                  <v-radio
                    label="Conlifct of interest"
                    value="conflict"
                  ></v-radio>
                  <v-radio label="Innapropriate" value="language"></v-radio>
                  <v-radio label="Privacy concern" value="privacy"></v-radio>
                  <v-radio label="Legal issue" value="legal"></v-radio>
                  <v-radio label="Duplicate" value="duplicate"></v-radio>
                </v-radio-group>
              </v-container>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="reportDialog = false; onReport()">
                  Report Abuse
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Reviews',
  props: {
    reviewData: Object,
  },
  data() {
    return {
      isHelpful: false,
      isReported: false,
      reviewRating: 3.5,
      reportDialog: false,
      radioGroup: 1,
      language: false,
      conflict: false,
      legal: false,
      privacy: false,
      duplicate: false,
      irrelevant: false,
    };
  },
  filters: {
    date: function(val) {
      let split = val.split(' ');
      return split.splice(1, 3).join(' ');
    },
  },
  methods: {
    onHelpful() {
      this.isHelpful = true;

      this.$store.dispatch('setSnackbar', {
        color: 'success',
        text: 'This review was marked as helpful.',
      });
    },
    onReport() {
      this.isReported = true;

      this.$store.dispatch('setSnackbar', {
        color: 'warning',
        text: 'This review was reported for abuse.',
      });
    },
  },
};
</script>

<style scoped>
  @media screen and (max-width: 542px) {
    .rating-and-date {
      width: 1%;
    }
  }

.review-first-row {
  width: 100%;
  display: flex;
  align-items: center;
}
.v-application p {
  margin-bottom: 0;
}

.v-application .headline {
  margin: auto;
}
</style>
